import React, { useState } from 'react';
import { Job } from '../../../../app/Slices/SevenDayApiTypes';
import { Box, Divider, Stack, Typography, styled } from '@mui/material';
import { useNavigate } from 'react-router';
import { NavigateNext } from '@mui/icons-material';
import UserRole from '../../../../shared/AuthRoles';
import ContractorJobPreview from '../../Contractors/Jobs/ContractorJobPreview';
import { camelCaseToTitleCase } from '../../../../shared/utils';

interface JobDetailsProps {
    job: Job;
}

const ActionBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    paddingRight: theme.spacing(2),
    transition: 'padding-right 0.3s ease-in-out',
    '&:hover': {
        paddingRight: theme.spacing(1),
    },
}));

const JobDetails = ({ job }: JobDetailsProps) => {
    const loggedInUser = UserRole();
    const navigate = useNavigate();

    const [previewOpen, setPreviewOpen] = useState(false);

    return (
        <div>
            <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                Job Details
            </Typography>
            <Stack divider={<Divider />} spacing={1}>
                <ActionBox onClick={() => setPreviewOpen(true)}>
                    <Typography sx={{ fontWeight: 'bold' }}>
                        Job #{job.id}
                    </Typography>
                    <NavigateNext />
                </ActionBox>
                {loggedInUser?.role.includes('owner') && (
                    <ActionBox
                        onClick={() =>
                            navigate(`/contractors/${job.contractor.id}`)
                        }
                    >
                        <div>
                            <Typography sx={{ fontWeight: 'bold' }}>
                                Contractor
                            </Typography>
                            <Typography>{job.contractor.name}</Typography>
                        </div>
                        <NavigateNext />
                    </ActionBox>
                )}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        p: 1,
                    }}
                >
                    <Typography sx={{ fontWeight: 'bold' }}>Date</Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                        }}
                    >
                        <Typography>
                            {new Date(job.jobDate).toDateString()}
                        </Typography>
                        {job.startTime && (
                            <Typography>
                                {job.startTime} - {job.endTime}
                            </Typography>
                        )}
                    </Box>
                </Box>

                <Box sx={{ p: 1 }}>
                    <Typography sx={{ fontWeight: 'bold' }}>
                        Services Required
                    </Typography>
                    <Typography>
                        {job.services
                            .map((service) => camelCaseToTitleCase(service))
                            .join(', ')}
                    </Typography>
                </Box>
                {loggedInUser?.role.includes('owner') && (
                    <ActionBox
                        onClick={() =>
                            navigate(
                                `/reservations/${job.module.name
                                    .replace(/\s/g, '')
                                    .toLowerCase()}/${job.booking.id}`,
                            )
                        }
                    >
                        <Typography sx={{ fontWeight: 'bold' }}>
                            Reservation #{job.booking.id}
                        </Typography>
                        <NavigateNext />
                    </ActionBox>
                )}
            </Stack>
            <ContractorJobPreview
                id={job.id}
                open={previewOpen}
                onClose={() => setPreviewOpen(false)}
            />
        </div>
    );
};

export default JobDetails;
